import React from "react";

const Verified = () => {
  return (
    <div>
      <a className="text-success text-xs mb-0" href="javascript:;">
        <i
          className="fa fa-check-circle-o text-xs text-success me-2"
          aria-hidden="true"
        ></i>
        Telah Diverifikasi
      </a>
    </div>
  );
};

export default Verified;
